import { render, staticRenderFns } from "./RkjhEdit.vue?vue&type=template&id=5b9b7ec8&scoped=true"
import script from "./RkjhEdit.vue?vue&type=script&lang=js"
export * from "./RkjhEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9b7ec8",
  null
  
)

export default component.exports